<template>
  <div class="norem-open-time">
    <h1 class="m-font-1">开放时间</h1>
    <div class="open-content">
      <!-- <div class="flex-box ml-40">
        <img src="../../assets/images/icon_time@2x.png" alt="">
        <div>
          <div class="date mb-10 m-font-2">4月1日至10月31日</div>
          <div class="week  mb-10">周二至周日：09:00 - 17:00 16:30停止入场</div>
          <div class="close">周一闭馆（除法定节假日）</div>
        </div>
      </div> -->

      <!-- <div class="child-hall flex-box">
        <img src="../../assets/images/icon_time@2x.png" alt="">
        <div>
          <div class="date mb-10 m-font-2">11月1日至3月31日</div>
          <div class="week  mb-10">周二至周日：09:00 - 16:30 16:00停止入场</div>
          <div class="close">周一闭馆（除法定节假日）、除夕闭馆</div>
        </div>
      </div> -->

      <div class="child-hall flex-box">
        <img src="../../assets/images/icon_time@2x.png" alt="">
        <div>
          <div class="date mb-10 m-font-2">辽宁省博物馆</div>
          <div class="week  mb-10">周二至周日：09:00 - 17:00&nbsp;16:30停止入场</div>
          <div class="close">周一闭馆（除法定节假日）、除夕闭馆</div>
        </div>
      </div>

      <div class="flex-box  ml-40">
        <img style="width: 38px;height: 27px;" src="../../assets/images/icon_chid@2x.png" alt="">
        <div>
          <div class="date mb-10 m-font-2">儿童体验馆</div>
          <div class="week  mb-10">周二至周日：上午 09:30 - 11:00 下午 13:00 - 14:30 15:00 - 16:30</div>
          <div class="close">周一闭馆（除法定节假日）、除夕闭馆</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.norem-open-time {
  width: 100%;
  h1 {
    margin-bottom: 60px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }

  .ml-40{
    margin-left: 40px;
  }

  .open-content {
    .flex-box {
      img {
        width: 30px;
        height: 30px;
        margin-right: 24px;
      }
    }
    .date {
      // font-size: 24px;
      font-weight: 400;
      color: #000000;
    }

    .week,
    .close {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
    }

    .child-hall {
      background: #f6f6f6;
      padding: 35px 0 35px 40px;
      margin: 70px 0;
    }

    .close {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: block;
        background: #ae8148;
        position: relative;
        top: 1px;
        width: 3px;
        height: 17px;
        margin-right: 9px;
      }
    }
  }
}
</style>